import { GoogleCalendar } from '../translations-types';

const translations: GoogleCalendar = {
  title: 'Google Agenda',
  description: 'Koppel je Google Agenda om de afspraken van vandaag te zien en te matchen met je cliënten.',
  connectCalendar: 'Google Agenda koppelen',
  disconnectCalendar: 'Ontkoppelen',
  connected: 'Gekoppeld',
  notConnected: 'Niet gekoppeld',
  connectedAs: 'Gekoppeld als',
  connectedAt: 'Gekoppeld sinds',
  connecting: 'Bezig met koppelen...',
  disconnecting: 'Bezig met ontkoppelen...',
  connectSuccess: 'Google Agenda succesvol gekoppeld.',
  disconnectSuccess: 'Google Agenda ontkoppeld.',
  connectError: 'Koppelen van Google Agenda mislukt. Probeer het opnieuw.',
  reconnecting: 'Verbinding met Google Agenda verlopen — je wordt opnieuw verbonden…',
  scopeMissingTitle: 'Agenda-toestemming ontbreekt',
  scopeMissingDescription:
    'De koppeling heeft geen toegang tot je agenda’s. Klik op "Google Agenda koppelen" en vink op het Google-scherm de agenda-toestemming expliciet aan.',
  todayAppointments: 'Afspraken van vandaag',
  noAppointments: 'Geen afspraken vandaag.',
  time: 'Tijd',
  client: 'Cliënt',
  matchedCustomer: 'Gevonden cliënt',
  notMatched: 'Niet gevonden',
  calendarNotConnected: 'Agenda niet gekoppeld',
  connectToSeeAppointments: 'Koppel je Google Agenda om de afspraken van vandaag te zien.',
  selectCalendar: 'Kies agenda',
  selectCalendarDescription: 'Kies welke agenda gebruikt wordt voor afspraken.',
  selectedCalendar: 'Geselecteerde agenda',
  changeCalendar: 'Wijzigen',
  defaultCalendar: '(Standaard)',
  save: 'Opslaan',
  loadingCalendars: "Agenda's laden...",
  appointments: 'Afspraken',
  today: 'Vandaag',
  tomorrow: 'Morgen',
  thisWeek: 'Deze week',
  panelTitle: 'Google-agenda (Salonized)',
  salonizedNote:
    'Deze Google-agenda wordt gevuld dóór Salonized. Medewerker, behandeling en een Salonized-link worden uit de afspraken overgenomen.',
  sync: 'Synchroniseer nu',
  syncPastYear: 'Synchroniseer afgelopen jaar',
  syncDone: 'Synchronisatie voltooid',
  added: 'Toegevoegd',
  updated: 'Bijgewerkt',
  removed: 'Verwijderd',
  matchedCustomers: 'Gematchte klanten',
  unmatchedCustomers: 'Niet-gematchte klanten',
  ambiguous: 'Meerdere matches',
  openInSalonized: 'Open in Salonized',
  calendarRequired: 'Agenda kiezen vereist',
  calendarRequiredNote: 'De koppeling is pas voltooid als je hieronder een agenda kiest; anders wordt er niets gesynchroniseerd.',
  connectedChooseCalendar: 'Verbonden met Google — kies nu een agenda om de koppeling te voltooien.',
  calendarModeSalon: 'Eén agenda voor de hele salon',
  calendarModeEmployee: 'Per medewerker',
  employeeCalendarsTitle: 'Agenda per behandelende medewerker',
  employeeColumn: 'Medewerker',
  calendarColumn: 'Agenda',
  noCalendarAssigned: 'Geen agenda',
  employeeCalendarsHint:
    'Kies per behandelende medewerker een agenda. Alleen agenda’s die met het gekoppelde Google-account gedeeld zijn verschijnen in de lijst.',
  assignAtLeastOne: 'Wijs minstens één agenda aan een medewerker toe.',
  noTreatingEmployees: 'Geen behandelende medewerkers voor deze vestiging.',
  goBookyPanelTitle: 'Google-agenda (GoBooky)',
  goBookyNote:
    'Deze Google-agenda wordt gevuld dóór GoBooky. Wijs per behandelende medewerker een agenda toe; de klant komt uit het "Klant:"-veld (gematcht op naam of e-mail) en de behandeling uit de afspraaktitel.',
};

export default translations;
